(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoTypeIbqDetailController', VideoTypeIbqDetailController);

    VideoTypeIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'VideoType'];

    function VideoTypeIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, VideoType) {
        var vm = this;

        vm.videoType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:videoTypeUpdate', function(event, result) {
            vm.videoType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
